import React from "react";
import { Document, Font, Page, Text, View } from "@react-pdf/renderer";
import { UserResultProps } from "../../../api/types";
import { AssignmentHeader, AssignmentResultsContent } from "./AssignmentPage";
import { CurriculumHeader, CurriculumResultsContent } from "./CurriculumPage";
import { AppendixHeader, AppendixContent } from "./AppendixPage";
import { EngagementHeader, EngagementContent } from "./EngagementPage";
import { CommentHeader, CommentContent } from "./CommentPage";

Font.register({
	src: `/fonts/PublicSans-Medium.ttf`,
	family: "Public Sans",
	fontWeight: "medium",
});

Font.register({
	family: "Inter",
	fonts: [
		{
			src: `/fonts/Inter-Regular.ttf`,
		},
		{
			src: `/fonts/Inter-Medium.ttf`,
			fontWeight: "medium",
		},
		{
			src: `/fonts/Inter-SemiBold.ttf`,
			fontWeight: "semibold",
		},
		{
			src: `/fonts/Inter-Bold.ttf`,
			fontWeight: "bold",
		},
	],
});

Font.registerHyphenationCallback((word) => [word]);

export interface DocumentProps {
	data: UserResultProps;
}

export const IndividualResultTemplate: React.FC<DocumentProps> = ({ data }) => {
	if (data) {
		return (
			<Document title={data.name + " Academic Result"}>
				{/* 794x1123 is the page size of the high fidelity */}
				<Page size={[794, 1123]}>
					<AssignmentHeader
						name={"Student: " + data.name}
						yearLevel={data.yearLevel}
						date={data.date}
					/>
					<AssignmentResultsContent data={data.assignmentResults} />
				</Page>
				<Page size={[794, 1123]}>
					<CurriculumHeader />
					<CurriculumResultsContent data={data.curriculumResults} />
				</Page>
				<Page size={[794, 1123]}>
					<EngagementHeader />
					<EngagementContent data={data} />
				</Page>
				<Page size={[794, 1123]}>
					<CommentHeader />
					<CommentContent data={data.comments} name={data.name} />
				</Page>
				<Page size={[794, 1123]}>
					<AppendixHeader />
					<AppendixContent data={data.assignmentResults} />
				</Page>
			</Document>
		);
	} else
		return (
			<Document>
				<Page size="A4">
					<View>
						<Text>This Pdf could not be generated</Text>
					</View>
				</Page>
			</Document>
		);
};
